import { durationText } from '@/utils/durationUtils'

const Options = ({ variantOptions }) => (
  Object.values(variantOptions).map(variant => {
    const { duration, id } = variant

    return (
      <option
        key={id}
        value={id.toString()}
      >
        {durationText(duration)}
      </option>
    )
  })
)

export default Options
